<script setup lang="ts">
import type { ReviewCompany } from "@/types/Ranking";
import iconHouse from "@/assets/images/icon_house.png";
import iconMansion from "@/assets/images/icon_mansion.png";

const props = defineProps<{
  type: "house" | "mansion";
  companies: ReviewCompany[];
}>();

const meta = computed(() =>
  props.type === "house"
    ? { icon: iconHouse, title: "【戸建て】口コミ・評判", anchor: "review-house" }
    : {
        icon: iconMansion,
        title: "【マンション】口コミ・評判",
        anchor: "review-mansion",
      }
);
</script>

<template>
  <section :class="['reviews', `reviews--${type}`]">
    <AtomsRankingHeading
      :icon="meta.icon"
      :title="meta.title"
      :anchor-id="meta.anchor"
    />
    <div class="reviews-list">
      <MoleculeRankingReviewCard
        v-for="(company, idx) in companies"
        :key="idx"
        :company="company"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.reviews--house :deep(.secHeading-icon) {
  width: 22px;
  height: auto;
}

.reviews--mansion :deep(.secHeading-icon) {
  width: 15px;
  height: auto;
}

.reviews-list {
  display: flex;
  flex-direction: column;
}

.reviews-list > :deep(.reviewCard:not(:last-child)) {
  border-bottom: 1px solid $colorGray;
}

@include media(pc) {
  .reviews--house :deep(.secHeading-icon) {
    width: 25px;
    height: auto;
  }

  .reviews--mansion :deep(.secHeading-icon) {
    width: 20px;
    height: auto;
  }

  .reviews-list {
    margin: 0 0 16px;
  }
}
</style>
